// extracted by mini-css-extract-plugin
export default {"wrap":"RF-z","subtitle":"SF-z","contentWrap":"TF-z","imgWrap":"UF-z","heading":"VF-z","copy":"WF-z"};